
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/hooks/useAuth';
import { SEO } from '@/components/seo/SEO';
import { Layout } from '@/components/layout/Layout';
import { BusinessPostForm } from '@/components/business/BusinessPostForm';

const BusinessTutoringWrite = () => {
  const { user, loading, initialized } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  
  // Check if the user is authenticated and has the right email
  useEffect(() => {
    if (!loading && initialized) {
      // First check if user is logged in
      if (!user) {
        toast({
          variant: "destructive",
          title: "로그인이 필요합니다",
          description: "게시글을 작성하려면 로그인해주세요."
        });
        navigate('/login', { replace: true });
      } 
      // Then check if they have the right permissions
      else if (user.email !== 'ilwoonge@gmail.com') {
        toast({
          variant: "destructive",
          title: "권한이 없습니다",
          description: "한인레슨/업체 등록 권한이 없습니다."
        });
        navigate('/business-tutoring', { replace: true });
      }
    }
  }, [user, loading, initialized, navigate, toast]);

  // Show loading state
  if (loading) {
    return (
      <Layout>
        <div className="container py-8 flex items-center justify-center">
          <p>로딩 중...</p>
        </div>
      </Layout>
    );
  }
  
  // Only show the form if the user is authenticated and has the right email
  if (!user || user.email !== 'ilwoonge@gmail.com') {
    return null;
  }

  return (
    <Layout>
      <SEO title="한인레슨/업체 글쓰기" description="한인레슨, 업체, 오픈톡방 정보를 등록하세요" />
      
      <div className="container py-8 max-w-screen-lg">
        <h1 className="text-3xl font-bold mb-6">한인레슨/업체 글쓰기</h1>
        <BusinessPostForm user={user} />
      </div>
    </Layout>
  );
};

export default BusinessTutoringWrite;
